module.exports = __webpack_public_path__ + "static/media/red_cross.013b13b5.png";